import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#c8102e",
      d: "M0 0h640.1v480H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M205.7 0h68.6v480h-68.6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 205.7h640.1v68.6H0z"
    }, null, -1)
  ]))]))
}
export default { render: render }